// pages/FormViewerPage/hooks/useFormViewer/capiStash.ts — stash sinyal CAPI utk fire tertunda (split dari submitCapi.ts)
export function stashCapiSignals(args: {
  orderId: string;
  fbc?: string | null; fbp?: string | null; pageUrl: string;
  ttclid?: string | null; ttp?: string | null; externalId?: string | null;
  metaPixelIds: string[]; tiktokPixelIds: string[]; googlePixelIds: string[];
  openaiPixelIds: string[]; oppref?: string | null; obref?: string | null;
}): void {
  const { orderId, fbc, fbp, pageUrl, ttclid, ttp, externalId, metaPixelIds, tiktokPixelIds, googlePixelIds, openaiPixelIds, oppref, obref } = args;
  try {
    if (!sessionStorage.getItem(`capi_stashed_${orderId}`)) {
      fetch('/api/capi/stash', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId, fbc: fbc || null, fbp: fbp || null, pageUrl, ttclid: ttclid || null, ttp: ttp || null, externalId: externalId || null, metaPixelIds, tiktokPixelIds, googlePixelIds, openaiPixelIds, oppref, obref }),
      }).catch(() => {});
      sessionStorage.setItem(`capi_stashed_${orderId}`, '1');
    }
  } catch { /* */ }
}
